<wiz-hgroup width="100%" height="100%" class="section-container-parent" padding="5px">
  <wiz-vgroup width="250px" height="100%" class="section-container"
    ><!-- zone champs libres & filtre -->
    <wiz-hgroup  width="100%">
      <wiz-label [wizLabel]="'$.pivot.edit.field.all.$'" class="smallTitleLabel"></wiz-label>
      <wiz-icon  style="cursor: pointer;" class="image-purple"  [wizTooltip]="'$.common.delete.$'"  (click)="onDeleteClick()">delete </wiz-icon>
    </wiz-hgroup>
    
    <wiz-list
      #freeList
      height="100%"
      width="100%"
      [wizItemRenderer]="renderer"
      id="freeList"
      [wizDataProvider]="dataSource"
      [wizLabelField]="'fullCode'"
      [dragEnabled]="true"
    ></wiz-list>
    <filter-component #mainFilter> </filter-component>
  </wiz-vgroup>

  <wiz-vgroup #vgDetailZone width="100%" height="100%">
    <!-- zone détail : poser les champs -->

    <wiz-vgroup width="100%" height="50%" minHeight="100px" class="section-container" ><!-- champs filtres --> 
      <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
        <wiz-icon class="image-purple">icon-filters</wiz-icon>
        <wiz-label [wizLabel]="'$.pivot.edit.field.filter.$'" class="smallTitleLabel"></wiz-label>
      </wiz-hgroup>
      <wiz-list
        #lstFilter
        id="lstFilter"
        width="100%"
        height="100%"
        [wizLabelField]="'label'"
        [wizItemRenderer]="renderer"
        [dragEnabled]="true"
        [dropEnabled]="true"
        [enableSelfReorder]="true"
        [shopDropIndicator]="true"
        [dragMove]="true"
      ></wiz-list>
  </wiz-vgroup>

    <wiz-vgroup width="100%" height="100%" style="display: none"
      ><!-- champs lignes masqué -->
      <wiz-list #lstRow></wiz-list>
      <wiz-list #lstColumn></wiz-list>
      <!-- <wiz-list #lstFilter></wiz-list> -->
      <wiz-list #lstGroup></wiz-list>
    </wiz-vgroup>

    <wiz-vgroup width="100%" height="70%" minHeight="100px" class="section-container"><!-- champs datas -->
      <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
        <wiz-icon class="image-purple">icon-formula</wiz-icon>
        <wiz-label [wizLabel]="'$.pivot.edit.form.fields.$'" class="smallTitleLabel"></wiz-label>
      </wiz-hgroup>
      <tile-gridster wizDragDrop [wizDropEnabled]="true" width="100%" height="100%" 
                  (widgetsChanged)="onWidgetsChanged($event)"
                  [model]="model"
                  [widget]="widget"
                  [fei]="fei"
                  [context]="context"
                  [entity]="entity"
                  [widgets]="widgets" [templatingMode]="true"></tile-gridster>
    </wiz-vgroup>

    <!-- zone contrôle d'intégrité, masquée -->
    <wiz-hgroup width="100%" height="30%" minHeight="100px" [visible]="false"> 

      <wiz-vgroup width="100%" height="100%" class="section-container"><!-- zone contrôle d'intégrité -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-formula</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.field.integrity.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>
        
        <wiz-checkbox #cbDeleteIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.delete.$'"></wiz-checkbox>
        <wiz-list
          #lstIntegrity
          id="lstDeleteCheck"
          width="100%"
          height="100%"
          [wizLabelField]="'label'"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
        ></wiz-list>
        <wiz-checkbox #cbUpdateIntegrity [visible]="true" [wizLabel]="'$.pivot.edit.integrity.update.$'"></wiz-checkbox>
      </wiz-vgroup>

      <wiz-vgroup width="100%" height="100%" class="section-container"><!-- zone contrôle d'intégrité -->
        <wiz-hgroup width="100%" class="widget-header" [verticalAlign]="'center'" padding="10px">
          <wiz-icon class="image-purple">icon-line</wiz-icon>
          <wiz-label [wizLabel]="'$.pivot.edit.subform.$'" class="smallTitleLabel"></wiz-label>
        </wiz-hgroup>

        <wiz-checkbox #cbShowNextStep [wizLabel]="'$.pivot.edit.show.nextstep.$'"></wiz-checkbox>
        <wiz-vgroup  #gpNextStep width="100%" height="100px" [visible]="false"><!-- champs colonnes, masqué-->
          <wiz-list #lstData
          id="lstData" width="100%" height="100%"
          [wizItemRenderer]="renderer"
          [dragEnabled]="true"
          [dropEnabled]="true"
          [enableSelfReorder]="true"
          [shopDropIndicator]="true"
          [dragMove]="true"
          ></wiz-list>
        </wiz-vgroup>
    </wiz-vgroup>

    </wiz-hgroup>



    <wiz-hgroup width="100%" [horizontalAlign]="'end'" verticalAlign="center" class="section-container">
      <!-- zone d'action de suppression / sélection, masquée -->
      <wiz-vgroup width="100%" [visible]="false">
        <wiz-vgroup gap="0">
          <wiz-checkbox #cbShowDeleteCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.$'"></wiz-checkbox>
          <wiz-checkbox #cbShowDeleteRecurseCol [visible]="true" [wizLabel]="'$.pivot.edit.show.delete.recurse.$'"></wiz-checkbox>
        </wiz-vgroup>
        <wiz-checkbox #cbShowSelectCol [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
        <wiz-checkbox #cbSelectUnique [visible]="false" [wizLabel]="'$.pivot.edit.show.select.$'"></wiz-checkbox>
      </wiz-vgroup>
      <wiz-button
        #btnSave
        width="150px"
        (click)="doValid()"
        [wizLabel]="'$.common.save.modification.$'"
        [wizIcon]="'icon-arrow-right'"
        [iconPlacement]="'right'"
      ></wiz-button>
      <wiz-button
        #btnCancel
        width="150px"
        (click)="doCancel()"
        class="cancel-button"
        [wizIcon]="'icon-arrow-left'"
        [wizLabel]="'$.common.cancel.modification.$'"
      ></wiz-button>
    </wiz-hgroup>
  </wiz-vgroup>
  <!-- fin zone détail -->
</wiz-hgroup>
